// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input {
  height: 10.8rem;
  background: var(--white);
  border: 0.1rem dashed white;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}
.input:hover, .input.file-over {
  border-color: var(--primary);
}
.input.file-over {
  background: var(--primary-10);
}
.input input {
  display: none;
}
.input .text {
  font-size: 1.4rem;
  line-height: 2.4rem;
  color: var(--black);
  display: flex;
  align-items: center;
}
.input .text.grey {
  color: var(--grey-text);
}
.input .text i {
  font-size: 2.4rem;
  color: var(--primary);
  margin-right: 0.6rem;
}
.input .text span {
  text-decoration: underline;
  margin-left: 0.4rem;
  color: var(--span-text-color);
}

.file-list {
  display: flex;
  gap: 2rem;
}

.file {
  width: 20rem;
  height: 4.8rem;
  padding: 0.8rem 0.6rem;
  background: var(--white);
  border: 0.1rem solid var(--chart-grey);
  border-radius: 0.8rem;
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 0.4rem 0.6rem;
  transition: box-shadow 0.2s;
}
.file .type {
  font-size: 2.4rem;
  grid-row: 1/-1;
  align-self: center;
}
.file .type:hover {
  cursor: pointer;
}
.file .name {
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--black);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.file .info {
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--grey);
  text-transform: uppercase;
}
.file .delete {
  font-size: 1.8rem;
  color: var(--grey);
  grid-column-end: -1;
  grid-row: 1/-1;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.2s;
}
.file > i .mtd-icon-paper-clip {
  color: var(--primary);
}
.file:hover {
  box-shadow: 0 0.4rem 1rem rgba(97, 97, 97, 0.18);
}
.file:hover .delete {
  opacity: 1;
}

.add-files {
  width: 20rem;
  height: 4.8rem;
  padding: 0.8rem 0.6rem;
  border: 0.1rem dashed var(--grey-text);
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.add-files input {
  display: none;
}
.add-files .text {
  font-size: 1.2rem;
  color: var(--grey-text-second);
  display: flex;
  align-items: center;
  gap: 1rem;
}
.add-files .text span {
  font-size: 2rem;
  line-height: 2.4rem;
  color: var(--primary);
}
.add-files:hover, .add-files:active {
  background: var(--white);
}
.add-files:active {
  color: var(--primary);
}

.mtd-icon-paper-clip {
  color: var(--primary);
}`, "",{"version":3,"sources":["webpack://./src/shared/upload-file/upload-file.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,wBAAA;EACA,2BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,oDACE;AAAJ;AAGE;EAEE,4BAAA;AAFJ;AAKE;EACE,6BAAA;AAHJ;AAME;EACE,aAAA;AAJJ;AAOE;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AALJ;AAOI;EACE,uBAAA;AALN;AAQI;EACE,iBAAA;EACA,qBAAA;EACA,oBAAA;AANN;AASI;EACE,0BAAA;EACA,mBAAA;EACA,6BAAA;AAPN;;AAYA;EACE,aAAA;EACA,SAAA;AATF;;AAYA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,sCAAA;EACA,qBAAA;EACA,aAAA;EACA,oCAAA;EACA,kCAAA;EACA,uBAAA;EACA,2BAAA;AATF;AAWE;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AATJ;AAWI;EACE,eAAA;AATN;AAaE;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAXJ;AAcE;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAZJ;AAeE;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,wBAAA;AAbJ;AAgBE;EACE,qBAAA;AAdJ;AAiBE;EACE,gDAAA;AAfJ;AAiBI;EACE,UAAA;AAfN;;AAoBA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EACA,sCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAjBF;AAmBE;EACE,aAAA;AAjBJ;AAoBE;EACE,iBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAlBJ;AAoBI;EACE,eAAA;EACA,mBAAA;EACA,qBAAA;AAlBN;AAsBE;EAEE,wBAAA;AArBJ;AAwBE;EACE,qBAAA;AAtBJ;;AA0BA;EACE,qBAAA;AAvBF","sourcesContent":[".input {\n  height: 10.8rem;\n  background: var(--white);\n  border: 0.1rem dashed white;\n  border-radius: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  cursor: pointer;\n  transition:\n    background-color 0.2s,\n    border-color 0.2s;\n\n  &:hover,\n  &.file-over {\n    border-color: var(--primary);\n  }\n\n  &.file-over {\n    background: var(--primary-10);\n  }\n\n  & input {\n    display: none;\n  }\n\n  & .text {\n    font-size: 1.4rem;\n    line-height: 2.4rem;\n    color: var(--black);\n    display: flex;\n    align-items: center;\n\n    &.grey {\n      color: var(--grey-text);\n    }\n\n    & i {\n      font-size: 2.4rem;\n      color: var(--primary);\n      margin-right: 0.6rem;\n    }\n\n    & span {\n      text-decoration: underline;\n      margin-left: 0.4rem;\n      color: var(--span-text-color);\n    }\n  }\n}\n\n.file-list {\n  display: flex;\n  gap: 2rem;\n}\n\n.file {\n  width: 20rem;\n  height: 4.8rem;\n  padding: 0.8rem 0.6rem;\n  background: var(--white);\n  border: 0.1rem solid var(--chart-grey);\n  border-radius: 0.8rem;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  grid-template-rows: repeat(2, 1fr);\n  grid-gap: 0.4rem 0.6rem;\n  transition: box-shadow 0.2s;\n\n  & .type {\n    font-size: 2.4rem;\n    grid-row: 1/-1;\n    align-self: center;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  & .name {\n    font-size: 1.2rem;\n    line-height: 1.4rem;\n    color: var(--black);\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  & .info {\n    font-size: 1.2rem;\n    line-height: 1.4rem;\n    color: var(--grey);\n    text-transform: uppercase;\n  }\n\n  & .delete {\n    font-size: 1.8rem;\n    color: var(--grey);\n    grid-column-end: -1;\n    grid-row: 1/-1;\n    opacity: 0;\n    cursor: pointer;\n    transition: opacity 0.2s;\n  }\n\n  &>i .mtd-icon-paper-clip {\n    color: var(--primary);\n  }\n\n  &:hover {\n    box-shadow: 0 0.4rem 1rem rgba(97, 97, 97, 0.18);\n\n    & .delete {\n      opacity: 1;\n    }\n  }\n}\n\n.add-files {\n  width: 20rem;\n  height: 4.8rem;\n  padding: 0.8rem 0.6rem;\n  border: 0.1rem dashed var(--grey-text);\n  border-radius: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  & input {\n    display: none;\n  }\n\n  & .text {\n    font-size: 1.2rem;\n    color: var(--grey-text-second);\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n\n    & span {\n      font-size: 2rem;\n      line-height: 2.4rem;\n      color: var(--primary);\n    }\n  }\n\n  &:hover,\n  &:active {\n    background: var(--white);\n  }\n\n  &:active {\n    color: var(--primary);\n  }\n}\n\n.mtd-icon-paper-clip {\n  color: var(--primary);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
